import AdminRoutes from './Admin'
import AuthRoutes from './Auth'
import CommonRoutes from './App'

const AppRoutes = [
  ...AdminRoutes,
  ...AuthRoutes,
  ...CommonRoutes,
]

export { AppRoutes }
